import { Root, Trigger, Portal, Content, Item } from '@radix-ui/react-dropdown-menu';
import { useCallback, useEffect, useState } from 'react';
import { ClickableIcon } from '@zenid/web';
import { css, cx } from '../../../styled-system/css';
import { useAuth } from '#/utils/auth/useAuth';

// リリース当初はZEN Studyとログアウトのみとする
export function DropdownMenu({ className }: { className?: string }) {
  const { logout } = useAuth();
  const alignOffset = useAlignOffsetByWidth();
  return (
    <Root>
      <Trigger asChild>
        <ClickableIcon
          className={className}
          name="apps"
          color="colors.text.main"
          size="l"
          aria-label="ZENサービス選択メニュー"
        />
      </Trigger>
      <Portal>
        <Content className={contentStyle} align="end" alignOffset={alignOffset}>
          {/* ZEN StudyはまだZEN ID未対応のため非表示にしておく */}
          {/* <Item className={itemStyle}>
            <a href={import.meta.env.VITE_ZEN_STUDY_HOST} target="_blank" rel="noreferrer noopener">
              <div className={flex({ gap: '{spacing.8}' })}>
                <img src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/zen_study_short_logo.svg`} alt="ZEN Studyロゴ" />
                <ServiceName>ZEN Study</ServiceName>
              </div>
            </a>
          </Item>
          <Separator className={separatorStyle} /> */}
          {/* 項目を追加する際は以下のコメントアウトを外して使用する */}
          {/* <Item className={itemStyle}>
            <a href="/">
              <div className={flex({ gap: '{spacing.8}' })}>
                <img src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/dummy_logo.svg`} alt="ダミーのサービスロゴ" />
                <ServiceName>Bサービス</ServiceName>
              </div>
            </a>
          </Item>
          <Separator className={separatorStyle} /> */}
          <Item className={cx(labelStyle)}>
            <button
              type="button"
              onClick={logout}
              className={css({ cursor: 'pointer', width: '100%', textAlign: 'left', padding: '{spacing.8}' })}
            >
              ログアウト
            </button>
          </Item>
        </Content>
      </Portal>
    </Root>
  );
}

function useAlignOffsetByWidth() {
  const [offset, setOffset] = useState(0);
  const onResize = useCallback(() => {
    // PC、SPサイズによって開閉の起点となるメニューアイコンの右端からずらす位置を決定する
    if (window.innerWidth < 600) {
      setOffset(4);
    } else {
      setOffset(8);
    }
  }, []);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  return offset;
}

const contentStyle = css({
  width: '288px',
  backgroundColor: '{colors.background.white}',
  boxShadow: '{shadows.dropShadow}',
  borderRadius: '{radii.16}',
  padding: '{spacing.12} {spacing.12} {spacing.8}',
});

// メニュー項目を表示するようになったらコメントアウトを外す
// const separatorStyle = css({
//   border: '1px solid {colors.border.light}',
//   margin: '{spacing.8} 0',
// });

const labelStyle = css({
  textStyle: 'label.m',
});

// メニュー項目を表示するようになったらコメントアウトを外す
// function ServiceName({ children }: { children: ReactNode }) {
//   return <span className={labelStyle}>{children}</span>;
// }
